"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../../../theme");
/* eslint-disable quote-props */

var prefixWidth = 40;
var prefixMarginRight = 16;
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    secondary = _ref$palette.secondary,
    primary = _ref$palette.primary,
    light = _ref.light,
    dark = _ref.dark;
  return {
    root: {
      fontSize: '14px',
      lineHeight: '17px'
    },
    wrapper: {
      overflow: 'hidden',
      transition: 'height 0.3s',
      '& nav': {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    toggler: function toggler(props) {
      return {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        padding: '0 6px',
        transition: 'background-color .2s ease-in-out, color .2s ease-in-out, border-color .2s ease-in-out, box-shadow .2s ease-in-out',
        height: '48px',
        fontSize: '14px',
        letterSpacing: 'auto',
        textTransform: 'capitalize',
        color: '#fff',
        marginBottom: '-1px',
        border: '0',
        borderRadius: '10px',
        '&.active': {
          color: '#fff',
          '&::before': {
            content: '" "',
            width: '2px',
            height: '15px',
            borderRadius: ' 5px 0px 0px 5px;',
            right: '5px',
            position: 'absolute',
            backgroundColor: ' #fff',
            transition: 'width .2s ease-in-out'
          }
        },
        '&:hover': {
          backgroundColor: props.theme === 'dark' ? dark.persistantSideBar.link.borderLeftColor : light.persistantSideBar.hover.backgroundColor,
          color: '#fff'
        }
      };
    },
    icon: {
      fontSize: 20,
      color: '#ffffff',
      marginRight: prefixMarginRight,
      width: prefixWidth,
      flexShrink: 0,
      justifyContent: 'center',
      display: 'inline-flex'
    },
    indicator: {
      marginLeft: 'auto',
      transition: 'transform .2s ease-in-out',
      opacity: 0.4
    },
    rotateIndicator: {
      transform: 'rotate(180deg)'
    },
    prefix: {
      width: prefixWidth,
      justifyContent: 'center',
      display: 'inline-flex',
      flexShrink: 0,
      marginRight: prefixMarginRight,
      textTransform: 'uppercase'
    },
    prefixContent: {
      backgroundColor: 'transparent',
      borderRadius: 3,
      width: 23,
      color: '#fff',
      justifyContent: 'center',
      display: 'inline-flex'
    },
    link: function link(props) {
      return {
        display: 'flex',
        alignItems: 'center',
        color: '#ffffff',
        fontSize: '14px',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        height: '48px',
        borderRadius: '0 !important',
        textDecoration: 'none',
        padding: '16px',
        paddingLeft: '64px',
        transition: 'background-color .2s ease-in-out, color .2s ease-in-out, border-color .2s ease-in-out, box-shadow .2s ease-in-out',
        marginBottom: '-1px',
        backgroundColor: props.theme === 'dark' ? dark.persistantSideBar.link.borderLeftColor : light.persistantSideBar.mainHolder.backgroundColor,
        fontWeight: 300,
        '&.active': {
          color: '#fff',
          borderLeftColor: props.theme === 'dark' ? dark.persistantSideBar.link.borderLeftColor : light.persistantSideBar.link.borderLeftColor,
          backgroundColor: props.theme === 'dark' ? '#000000 !important' : 'rgb(0, 120, 105) !important'
        },
        '&:hover:not(.active)': {
          backgroundColor: props.theme === 'dark' ? dark.persistantSideBar.link.borderLeftColor : light.persistantSideBar.mainHolder.backgroundColor,
          color: '#fff'
        }
      };
    }
  };
}, {
  name: 'SideNavItem'
});
exports.useStyles = useStyles;